const footer = {
  navigation: {
    mainPage: 'Homepage',
    interactiveMap: 'Interactive map',
    reports: 'Reports',
  },
  pages: {
    termsAndConditions: 'Terms and Conditions',
    privacyPolicy: 'Privacy Policy',
  },
  categories: {
    businessServices: 'Business Services',
    supportAndHelp: 'Support and assistance',
    followUs: 'Follow us on',
  },
  initiativeBy: 'Initiative by',
}

export default footer;
